import { combineReducers } from "redux";

const Index = (state = [], action) => {
  const { payload, toasts, intl, id, ids } = action;
  switch (action.type) {
    case "SET_ALL_CATEGORIES_DATA":
      return payload;
    case "DELETE_CATEGORY_FROM_REDUX":
      const deleteData = state.data.filter((x) => (x.id === id ? false : x));
      return {
        ...state,
        data: deleteData,
      };
    case "MULTI_DELETE_CATEGORIES_FROM_REDUX":
      const deleteMultiData = state.data.filter((x) =>
        ids.includes(x.id) ? false : x
      );

      //   setAllIds([]);
      return {
        ...state,
        data: deleteMultiData,
      };
    default:
      return state;
  }
};

const showLoader = (state = false, action) => {
  const { type, showLoader } = action;
  switch (type) {
    case "SHOW_LOADER":
      return showLoader;
    default:
      return state;
  }
};

export const reducer = combineReducers({
  Index,
  showLoader,
});
